var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"az-signin-wrapper"},[_c('div',{staticStyle:{"padding":"50px"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('error_no_found.header'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('error_no_found.description'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }